import React, { useState , useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import DeleteConfirmation from "../../General/DeleteConfirmation";
import { showSuccess, showError,showWarning} from "../../General/Toast";

function EsitmateHistory({clientData}) {
  const navigate = useNavigate();
 const [searchTerm, setSearchTerm] = useState('');
 const[fetchEstimate,setFetchEstimate] = useState([]);
     const [selectedParty, setSelectedParty] = useState(null);
         const [showTxn, setShowTxn] = useState(false);
      const [showDelete, setShowDelete] = useState(false);        

const fetchEstimateHis = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-estimate-bill/${clientData.id}`);
     
      const sortedData = [...res.data].sort((a, b) => b.invoiceNo - a.invoiceNo);

    setFetchEstimate(sortedData);
     
    } catch (error) {
      console.log(error);
    }
  };   

   useEffect(() => {
     fetchEstimateHis();
  
    }, []);

    const filteredData = Array.isArray(fetchEstimate)
  ? fetchEstimate
      .filter((itm) =>
        Object.values(itm).some((val) =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
  : [];

 const handleDelete = async () => {
  try {
    await axios.put(
      `https://api.dectwinbilling.com/delete-estimate/${selectedParty.id}`,
      {
        party_id: selectedParty.party_id,
        invoiceNo: selectedParty.invoiceNo,
        client_id: selectedParty.client_id,
      }
    );

    setShowDelete(false);
    showSuccess("Estimated bill deleted successfully!", "success");
    fetchEstimateHis();
  } catch (err) {
    console.error(err);
    showError("Failed to delete estimate bill", "danger");
  }
};

  return (
    <>
         <div className="container-fluid py-4">
      <div className="card shadow border-0 rounded-4">
     <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
  <h4 className="mb-0 fw-bold">
    Estimate History
  </h4>

  <button className="btn btn-primary"
    onClick={() => navigate("/home")}
  >
    Back
  </button>
</div>
       

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover align-middle text-center">
              <thead >
                <tr>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Inv.No</th>
                    <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Customer Name</th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Customer Number</th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Date </th>
           <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Total </th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Activity</th>
                </tr>
              </thead>

  <tbody>
                   {filteredData.length === 0 ? (
        <tr>
          <td colSpan="8" className="text-center text-muted">
            No Transaction Found
          </td>
        </tr>
      ) : (
        filteredData.map((item, index) => (
          <tr key={item.id}>
            <td>{item.invoiceNo}</td>
            <td>{item.name}</td>
            <td>{item.mobile} </td>
            <td>{item.date}</td>
            <td> ₹{item.payable || 0}</td>
            
        <td> 

           <button className="btn btn-primary me-2" 
           onClick={() =>
    navigate("/add-estimate", {
      state: item,
    })
  }
           >
         Edit
          </button>

          {/* <button className="btn btn-danger "   onClick={() => {
    setSelectedParty(item);
    setShowDelete(true);
  }}>Delete </button> */}

        </td>
          </tr>
        ))
      )}
              </tbody>
        
            </table>
          </div>
        </div>
      </div>

           <DeleteConfirmation
  show={showDelete}
  title="Delete Estimate"
  message={`Are you sure you want to delete "${selectedParty?.name}"? This action cannot be undone.`}
  onConfirm={handleDelete }
  onCancel={() => setShowDelete(false)}
/>
    </div>
    </>
  )
}

export default EsitmateHistory
